<template> 
  <div style="background-color:white;min-height:500px">
    <v-row>
      <v-col
        cols="12"
        sm="6"
      >
        <img src="@/assets/products/comp_1.jpg" alt="" height="400" />
      </v-col>
      <v-col
        cols="12"
        sm="6"
      >
        <div style="padding-top:80px;">
          <div>
            <p style="font-size:36px;padding:0px;margin:0px;font-weight:200;font-family:Roboto">Motor Comprehensive Insurance</p>
          </div>
          <div style="padding-top:20px">
            <p>We have motor insurance in two categories of products.</p>
            <p>You can pick between Third Party and Comprehensive Insurance cover. All these policies are offered at affordable prices and cover can be obtained at any of our Branches, licensed Insurance Brokers or Agents of Professional Insurance.</p>
          </div>
          <div style="padding-left:25%;padding-top:15px">
            <v-btn
              color="primary"
              rounded
              outlined
              large
              @click="openDrawer(1)"        
            >
              Get a Quote
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
    
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  export default {
    name: 'MotorComprehensive',
    components: {
      
    },
    data() {
      return {
        
      }
    },
    methods: {
      openDrawer(index){
        this.components.nav_drawer.product_index=index;
        this.components.nav_drawer.mini_variant=false;
        this.components.nav_drawer.expand_on_hover=false;
        
      },
    },
    computed: {
      ...mapGetters({
        user: "user",
        components: "components"
      })
    } 
  }
</script>

